<template>
    <div class="my-scroll-ranking-board" :ref="ref">
        <!-- <div class="row-item" v-for="item in rows" :key="item.toString() + item.scroll" style="height: calc(33%);flex: 0 0 20%;"> -->
        <div class="row-item" v-for="item in rows" :key="item.toString() + item.scroll">
            <!-- :style="`height: ${heights[i]}px;`" -->
            <div class="ranking-info">
                <slot :item="item" v-if="item"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import autoResize from '../mixin/autoResize'

import {
  deepMerge
} from '@jiaminghi/charts/lib/util/index'

import {
  deepClone
} from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'DvScrollRankingBoard',
  mixins: [autoResize],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Number,
      default: 5
    },
    column: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      ref: 'scroll-ranking-board',

      defaultConfig: {
        /**
                     * @description Board data
                     * @type {Array<Object>}
                     * @default data = []
                     */
        data: [],
        /**
                     * @description Row num
                     * @type {Number}
                     * @default rowNum = 5
                     */
        rowNum: this.row * this.column,
        /**
                     * @description Scroll wait time
                     * @type {Number}
                     * @default waitTime = 2000
                     */
        waitTime: 2000,
        /**
                     * @description Carousel type
                     * @type {String}
                     * @default carousel = 'single'
                     * @example carousel = 'single' | 'page'
                     */
        carousel: 'single',
        /**
                     * @description Value unit
                     * @type {String}
                     * @default unit = ''
                     * @example unit = 'ton'
                     */
        unit: ''
      },

      mergedConfig: null,

      rowsData: [],

      rows: [],

      heights: [],

      animationIndex: 0,

      animationHandler: '',

      updater: 0
    }
  },
  watch: {
    config () {
      const {
        stopAnimation,
        calcData
      } = this

      stopAnimation()

      calcData()
    }
  },
  methods: {
    afterAutoResizeMixinInit () {
      const {
        calcData
      } = this

      calcData()
    },
    onResize () {
      const {
        mergedConfig,
        calcHeights
      } = this

      if (!mergedConfig) return

      calcHeights(true)
    },
    calcData () {
      const {
        mergeConfig,
        calcRowsData
      } = this

      mergeConfig()

      calcRowsData()

      const {
        calcHeights
      } = this

      calcHeights()

      const {
        animation
      } = this

      animation(true)
    },
    mergeConfig () {
      let {
        config,
        defaultConfig
      } = this

      this.mergedConfig = deepMerge(deepClone(defaultConfig, true), config || {})
    },
    calcRowsData () {
      let {
        data,
        rowNum
      } = this.mergedConfig

      // data.sort(({
      //     value: a
      // }, {
      //     value: b
      // }) => {
      //     if (a > b) return -1
      //     if (a < b) return 1
      //     if (a === b) return 0
      // })

      // const value = data.map(({
      //   value
      // }) => value)

      // const max = Math.max(...value) || 0

      // data = data.map((row, i) => ({ ...row,
      //     ranking: i + 1,
      //     percent: row.value / max * 100
      // }))

      const rowLength = data.length

      if (rowLength > rowNum && rowLength < 2 * rowNum) {
        data = [...data, ...data]
      }

      data = data.map((d, i) => ({ ...d,
        scroll: i
      }))

      this.rowsData = data
      this.rows = data
    },
    calcHeights (onresize = false) {
      const {
        height,
        mergedConfig
      } = this

      const {
        rowNum,
        data
      } = mergedConfig

      const avgHeight = height / rowNum

      this.avgHeight = avgHeight

      if (!onresize) this.heights = new Array(data.length).fill(avgHeight)
    },
    async animation (start = false) {
      let {
        avgHeight,
        animationIndex,
        mergedConfig,
        rowsData,
        animation,
        updater
      } = this

      const {
        waitTime,
        carousel,
        rowNum
      } = mergedConfig

      const rowLength = rowsData.length

      if (rowNum >= rowLength) return

      if (start) {
        await new Promise(resolve => setTimeout(resolve, waitTime))
        if (updater !== this.updater) return
      }

      const animationNum = carousel === 'single' ? 1 : rowNum

      let rows = rowsData.slice(animationIndex)
      rows.push(...rowsData.slice(0, animationIndex))

      this.rows = rows
      this.heights = new Array(rowLength).fill(avgHeight)

      await new Promise(resolve => setTimeout(resolve, 300))
      if (updater !== this.updater) return

      this.heights.splice(0, animationNum, ...new Array(animationNum).fill(0))

      animationIndex += animationNum

      const back = animationIndex - rowLength
      if (back >= 0) animationIndex = back

      this.animationIndex = animationIndex
      this.animationHandler = setTimeout(animation, waitTime - 300)
    },
    stopAnimation () {
      const {
        animationHandler,
        updater
      } = this

      this.updater = (updater + 1) % 999999

      if (!animationHandler) return

      clearTimeout(animationHandler)
    }
  },
  destroyed () {
    const {
      stopAnimation
    } = this

    stopAnimation()
  }
}
</script>

<style lang="less">
    @color: #1370fb;

    .my-scroll-ranking-board {
        width: 100%;
        height: 100%;
        color: #fff;
        overflow: hidden;
        /* display: flex;
        flex-wrap: wrap;
        align-content: flex-start; */

        .row-item {
            transition: all 0.3s;
            overflow: hidden;
            .ranking-info {
                /* height: calc(100% - 0.625rem);
                margin: 0.3125rem; */
                border-radius: 2px;
                // border: 1px solid rgba(57, 152, 255, 1);
            }
        }
    }

    @keyframes shine {
        80% {
            left: 0%;
            transform: translateX(-100%);
        }

        100% {
            left: 100%;
            transform: translateX(0%);
        }
    }
</style>
